export const policies = {
  game_store: {
    presets: {
      loyal: {
        badge: {
          text: 'You are eligible for a refund of this purchase within 14 days of payment.'
        },
        reasons: [
          "notReceived",
          "duplicate",
          "notCompatible",
          "notFunctioning",
          "general"
        ]
      },
      moderate: {
        badge: {
          text: 'Refunds are only available in the event that you’ve accidentally purchased multiple keys.'
        },
        reasons: ["notReceived", "duplicate", "notCompatible", "notFunctioning"]
      },
      strict: {
        badge: {
          text: 'Refunds are not generally available for this purchase.'
        },
        reasons: ["notReceived"]
      }
    }
  },
  pre_orders: {
    presets: {
      loyal: {
        badge: {
          text: 'You are eligible to claim a refund until 14 days after the official release of this game.'
        },
        reasons: [
          "notReceived",
          "duplicate",
          "notCompatible",
          "notFunctioning",
          "general"
        ]
      },
      moderate: {
        badge: {
          text: 'Refunds are available any time before game delivery, or if you’ve accidentally purchased multiple keys.'
        },
        reasons: ["notReceived", "duplicate", "notCompatible", "notFunctioning"]
      },
      strict: {
        badge: {
          text: 'A refund for this purchase is only guaranteed until the playable content has been delivered.'
        },
        reasons: ["notReceived"]
      }
    }
  },
  subscriptions: {
    presets: {
      loyal: {
        badge: {
          text: 'You are eligible for a one-time refund for this purchase within 48 hours of payment.'
        },
        reasons: [
          "notReceived",
          "duplicate",
          "notCompatible",
          "notFunctioning",
          "general"
        ]
      },
      moderate: {
        badge: {
          text: 'A refund is only available for the first renewal of this subscription, within 48 hours of payment.'
        },
        reasons: ["notReceived", "duplicate", "notCompatible", "notFunctioning"]
      },
      strict: {
        badge: {
          text: 'Refunds are not generally available for this purchase.'
        },
        reasons: ["notReceived"]
      }
    }
  },
  currency: {
    presets: {
      loyal: {
        badge: {
          text: 'This policy allows you to request a refund under many conditions.'
        },
        reasons: [
          "notReceived",
          "duplicate",
          "notCompatible",
          "notFunctioning",
          "general"
        ]
      },
      moderate: {
        badge: {
          text: 'This policy allows you to request a refund under several conditions.'
        },
        reasons: ["notReceived", "duplicate", "notCompatible", "notFunctioning"]
      },
      strict: {
        badge: {
          text: 'This policy only allows you to request a refund under a few conditions.'
        },
        reasons: ["notReceived"]
      }
    }
  },
  simple_checkout: {
    presets: {
      loyal: {
        badge: {
          text: 'This policy allows you to request a refund under many conditions.'
        },
        reasons: ["notReceived", "general"]
      },
      moderate: {
        badge: {
          text: 'This policy allows you to request a refund under several conditions.'
        },
        reasons: ["notReceived"]
      },
      strict: {
        badge: {
          text: 'This policy only allows you to request a refund under a few conditions.'
        },
        reasons: ["notReceived"]
      }
    }
  }
};
